import DPIntroTour from './modules/DPIntroTour';
import DPUserVisitCounter from './modules/DPUserVisitCounter';
import DpitHooks from '../../../includes/assets/js/modules/hooks';

window.DpitHooks = DpitHooks;

jQuery(window).on('load', () => {
	// jQuery(document).ready(function () {
	window.$ = jQuery;
	if (window.dpIntroTourPublicConfig.dpDebugEn) console.log('FREE config:', window.dpIntroTourPublicConfig);
	DPUserVisitCounter.processVisit(window.dpIntroTourPublicConfig);
	if (window.dpIntroTourPublicConfig.tours && window.dpIntroTourPublicConfig.tours.length) {
		window.dpIntroTourPublicConfig.tours.forEach((tourCfg) => {
			new DPIntroTour(window.dpIntroTourPublicConfig, tourCfg);
		});
	}
});
